import { WeatherDataPoint } from './mockWeatherData';

export function exportToCSV(data: WeatherDataPoint[], filename: string = 'weather_data.csv') {
  // Create CSV headers
  const headers = [
    'Czas',
    'Temperatura AHT (°C)',
    'Wilgotność AHT (%)',
    'Temperatura BMP (°C)',
    'Ciśnienie BMP (hPa)',
    'Temperatura DS18 (°C)',
    'Prędkość wiatru (km/h)',
    'Podmuchy wiatru (km/h)',
    'Opady (mm)',
    'Kierunek wiatru (°)',
    'Wilgotność gleby (%)',
  ];

  // Convert data to CSV rows
  const rows = data.map(point => [
    new Date(point.time).toLocaleString('pl-PL'),
    point.aht_temp.toFixed(2),
    point.aht_hum.toFixed(2),
    point.bmp_temp.toFixed(2),
    point.bmp_pres.toFixed(2),
    point.ds18_temp.toFixed(2),
    point.wind_speed.toFixed(2),
    point.wind_gust.toFixed(2),
    point.rain_mm.toFixed(2),
    point.wind_dir_val.toFixed(2),
    point.soil_moisture.toFixed(2),
  ]);

  // Combine headers and rows
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.join(',')),
  ].join('\n');

  // Add BOM for proper UTF-8 encoding in Excel
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });

  // Create download link
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(url);
}

export function exportCurrentData(data: WeatherDataPoint) {
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
  exportToCSV([data], `weather_current_${timestamp}.csv`);
}

export function exportHistoricalData(data: WeatherDataPoint[]) {
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
  exportToCSV(data, `weather_historical_${timestamp}.csv`);
}
